// extracted by mini-css-extract-plugin
module.exports = {"totalRequests":"ReportCardCompleteCount_totalRequests__3CJvD","totalRequests_period":"ReportCardCompleteCount_totalRequests_period__2xer0"};